export default __webpack_public_path__ + "static/media/MainBedroomEnSuite.8c89b697.png";